import { useEffect, useRef, useCallback } from 'react';
// eslint-disable-next-line jira/restricted/lottie
import Lottie from 'lottie-web';

export const useLottie = (animationData: unknown) => {
	const lottieDiv = useRef<unknown>(null);

	const loadLottie = useCallback(() => {
		const params = {
			container: lottieDiv.current,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData,
		};
		// @ts-expect-error - TS2345 - Argument of type '{ container: unknown; renderer: string; loop: boolean; autoplay: boolean; animationData: unknown; }' is not assignable to parameter of type 'AnimationConfigWithPath | AnimationConfigWithData'.
		Lottie.loadAnimation(params);
	}, [animationData]);

	// go/jfe-eslint
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(loadLottie, []);

	return { lottieDiv };
};
